import { API_ROOT } from "../constants/constants";
import { getAccessToken } from "../utils/okta-config";
import { toast } from "react-toastify";

export async function getAnnouncements(user) {
  let result = [];
    try {
      let url =
        `${process.env.REACT_APP_API_ENDPOINT}/home/getAnnouncements`;
      const requestOptions = {
        method: "GET",
        headers: {
          supplierNumber: user.supplierNumber,
          isInternal: (user.externalFactoryUser || user.internal) ? true : false, // to treat external factory user as internal for factory close dates
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };
      const response = await fetch(url, requestOptions);
      if(response.status === 200){
        result = await response.json();
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

export async function getUrgentActionsList(sapSupplierNumber) {
  let result = {};
  try {
    let url = `${process.env.REACT_APP_API_ENDPOINT}/home/getUrgentActions`;
    const requestOptions = {
      method: "GET",
      headers: {
        sapSupplierNumber: sapSupplierNumber,
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };
    const response = await fetch(url, requestOptions);
    
    if (response.status === 200) {
      // Success: Urgent actions found and retrieved
      result = await response.json();
    } else if (response.status === 204) {
      // No Content: No urgent actions found for the supplier
      const responseData = await response.json();
      console.info('No urgent actions found for supplier:', sapSupplierNumber);
      
      // Show warning toast with backend message if available
      if (responseData?.message) {
        toast.warn(responseData.message);
      } else {
        toast.warn('No urgent actions found for the selected supplier');
      }
      
      // Return empty structure for UI consistency
      result = {
        deliveryDateMissingOrders: [],
        latePickupLoadbuildOrders: [],
        vatMissingOrders: [],
        latePickupAvisOrders: []
      };
    } else if (response.status === 400) {
      // Bad Request: Invalid supplier number
      const responseData = await response.json();
      console.error('Invalid supplier number:', sapSupplierNumber);
      
      // Show error toast with backend message if available
      const errorMessage = responseData?.message || 'Invalid supplier number provided';
      toast.error(errorMessage);
      throw new Error(errorMessage);
    } else if (response.status === 500) {
      // Internal Server Error: Server-side error
      const responseData = await response.json();
      console.error('Internal server error while fetching urgent actions');
      
      // Show error toast with backend message if available
      const errorMessage = responseData?.message || 'Server error while fetching urgent actions';
      toast.error(errorMessage);
      throw new Error(errorMessage);
    } else {
      // Unexpected status codes
      console.error('Unexpected response status:', response.status);
      const errorMessage = `Unexpected error occurred (Status: ${response.status})`;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
    return result;
  } catch (error) {
    // Network errors or other fetch failures
    console.error('Error fetching urgent actions:', error);
    throw error;
  }
}